// ─── Rule Validation — spec §8.8 ──────────────────────────────────────────────
// Fires on Save ONLY. Returns errors object keyed by field path.

import { FIELD_TYPE_MAP, NO_VALUE_OPERATORS } from './cascadeConfig';

export function validateRule({ name, conditions, actions }) {
  const errors = {};

  // Rule name
  if (!name || !name.trim()) {
    errors.name = 'Please give this rule a name';
  }

  // Conditions — at least 1
  if (!conditions || conditions.length === 0) {
    errors.conditions = 'Add at least one condition to define when this rule applies';
  } else {
    conditions.forEach((cond, i) => {
      if (!cond.field) {
        errors[`condition_${i}_field`] = 'Select a field for this condition';
      }
      if (!cond.operator) {
        errors[`condition_${i}_operator`] = 'Select a condition type';
      }
      if (cond.operator && !NO_VALUE_OPERATORS.includes(cond.operator)) {
        if (cond.operator === 'between') {
          const v1 = parseFloat(cond.value);
          const v2 = parseFloat(cond.value2);
          if (isNaN(v1) || isNaN(v2)) {
            errors[`condition_${i}_value`] = 'Enter a value to compare against';
          } else if (v1 >= v2) {
            errors[`condition_${i}_value`] = 'From value must be less than to value';
          }
        } else if (cond.value === null || cond.value === undefined || cond.value === ''
                   || (Array.isArray(cond.value) && cond.value.length === 0)) {
          errors[`condition_${i}_value`] = 'Enter a value to compare against';
        } else {
          // Numeric validation
          const fieldType = FIELD_TYPE_MAP[cond.field];
          if (fieldType === 'number' && isNaN(parseFloat(cond.value))) {
            errors[`condition_${i}_value`] = 'Value must be a number';
          }
        }
      }
    });
  }

  // Actions — at least 1
  if (!actions || actions.length === 0) {
    errors.actions = 'Add at least one action to define what this rule does';
  } else {
    actions.forEach((action, i) => {
      if (!action.type) {
        errors[`action_${i}_type`] = 'Select an action type';
      } else if (action.type === 'add_tag') {
        if (!action.value?.tag_id && !action.value?.tag_name) {
          errors[`action_${i}_value`] = 'Please select a tag';
        }
      } else if (action.type === 'add_item') {
        const actionSkus = action.value?.skus?.length
          ? action.value.skus
          : (action.value?.sku?.trim() ? [action.value.sku.trim()] : []);
        if (actionSkus.length === 0) {
          errors[`action_${i}_sku`] = 'Select at least one product';
        }
        const qty = parseInt(action.value?.quantity, 10);
        if (!qty || qty < 1) {
          errors[`action_${i}_qty`] = 'Quantity must be a positive number';
        }
      }
    });
  }

  return errors;
}
